<template>
<div class="indexPage">
	<div class="wholePageBox indexImageBox" ref="headerImageRef">
		<img class="indexImage" src="@/assets/indexIMG.png" />
		<div class="indexTextBox">
			<div style="width: 8rem; height: 1rem; background-color: #FFFFFF;" />
			<div class="indexTitle" style="margin-top: 3rem;">
				AI赋能心理健康<br />
				AI Empowers Mental Wellness
			</div>
			<div class="indexText" style="margin-top: 3rem;">
				从机构到个体，让科技成为心灵疗愈的力量<br />
				Harnessing the Healing Power of Technology for the Mind
			</div>
		</div>
	</div>

	<div style="height: 11.7rem; width: 1px;" />
	<div class="visualBox">
		<div class="boxCNTitle">
			PULSE生态系统可视化图
		</div>
		<div style="width: 1px; height: 1rem" />

		<div class="boxENTitle">
			PULSE ECOSYSTEM VISUALIZATION
		</div>
		<div style="height: 6.7rem; width: 1px;" />

		<div class="visualBoxItemLine">
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index00.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					健康脑
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					老年认知健康管理
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index01.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					PULSE治愈
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					智慧自适应心理疗愈
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index02.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					心愿绘本
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					AI赋能心理显化工具
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index03.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					阴转晴
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					中重度心理专业咨询
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
		</div>
		<div style="height: 1.3rem; width: 1px;" />

		<div class="visualBoxItemLine">
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index04.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					PULSE健康
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					身心一体康复工具
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index05.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					职工心理
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					企业员工心理管理平台
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index06.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					青少年心理系统
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					校园心理健康管理
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
			<div class="visualBoxItem">
				<div style="flex: 458; width: 1px;" />

				<img class="visualBoxItemImage" src="@/assets/index07.png" object-fit="cover">
				<div style="flex: 250; width: 1px;" />
				
				<div class="visualBoxItemName">
					青松心理
				</div>
				<div style="flex: 49; width: 1px;" />

				<div class="visualBoxItemDesc">
					政企专属心理服务
				</div>
				<div style="flex: 569; width: 1px;" />
			</div>
		</div>
		<div style="height: 10.3rem; width: 1px;" />

	</div>

	<div class=" courseTypeBox">
		<div class="boxCNTitle">
			课程类型
		</div>
		<div style="width: 1px; height: 1rem" />

		<div class="boxENTitle">
			CORE DATA
		</div>
		<div style="height: 6.7rem; width: 1px;" />

		<div class="courseTypeLine" @pointerdown="handleDown" ref="line">
			<div class="courseTypeItem">
				<img class="courseTypePic" src="@/assets/course0.png" fit="cover" />

				<div class="courseTypeName">
					专属练习
				</div>
				<div class="courseTypeDesc">
					定制化专题练习，精准匹配情绪与康复需求，助力自我调节成长。
				</div>
			</div>
			<div class="courseTypeItem">
				<img class="courseTypePic" src="@/assets/course1.png" fit="cover" />

				<div class="courseTypeName">
					课程
				</div>
				<div class="courseTypeDesc">
					系统化心理课程，多主题覆盖，趣味轻量化，轻松学习心理知识。
				</div>
			</div>
			<div class="courseTypeItem">
				<img class="courseTypePic" src="@/assets/course2.png" fit="cover" />

				<div class="courseTypeName">
					心理测评
				</div>
				<div class="courseTypeDesc">
					科学权威测评，多维度评估状态，生成个性化健康报告与方案。
				</div>
			</div>
			<div class="courseTypeItem">
				<img class="courseTypePic" src="@/assets/course3.png" fit="cover" />

				<div class="courseTypeName">
					虚拟咨询师
				</div>
				<div class="courseTypeDesc">
					7×24 小时在线陪伴，疏导解答心理问题，提供温暖专业心理支持。
				</div>
			</div>
		</div>
		<div style="height: 11.7rem; width: 1px;" />

	</div>

	<div style="height: 6.7rem; width: 1px;" />
	<div>
		<div class="boxCNTitle">
			核心数据
		</div>
		<div style="width: 1px; height: 1rem" />

		<div class="boxENTitle">
			CORE DATA
		</div>

		<div style="height: 6.7rem; width: 1px;" />
		<div class="coreDataBox">
			<div
				class="coreDataItem"
				:class="{ active: activeCoreDataIndex === 0 }"
				@mouseenter="activeCoreDataIndex = 0"
			>
				<span class="coreDataItemText1">5+</span>
				<span class="coreDataItemText2">医疗与科研机构</span>
			</div>
			<div style="flex: 1; height: 1px;" />

			<div
				class="coreDataItem"
				:class="{ active: activeCoreDataIndex === 1 }"
				@mouseenter="activeCoreDataIndex = 1"
			>
				<span class="coreDataItemText1">2,000,000+</span>
				<span class="coreDataItemText2">次心理测评完成</span>
			</div>
			<div style="flex: 1; height: 1px;" />

			<div
				class="coreDataItem"
				:class="{ active: activeCoreDataIndex === 2 }"
				@mouseenter="activeCoreDataIndex = 2"
			>
				<span class="coreDataItemText1">100+</span>
				<span class="coreDataItemText2">政府及企业客户</span>
			</div>
		</div>
		<div style="height: 11.7rem; width: 1px;" />

	</div>

	<div style="height: 6.7rem; width: 1px;" />
	<template>
		<div class="boxCNTitle">
			合作伙伴
		</div>
		<div style="height: 1rem; width: 1px;" />
		<div class="boxENTitle">
			COLLABORATIVE PARTNER
		</div>
		<div style="height: 6.7rem; width: 1px;" />
		<div class="partnerBox" aria-label="Scrolling cards">
			<div class="track1">
				<!-- 第一组 -->
				<img class="card" src="../assets/index20.png">
				<img class="card" src="../assets/index21.png">
				<img class="card" src="../assets/index22.png">
				<img class="card" src="../assets/index23.png">
				<img class="card" src="../assets/index24.png">
				<img class="card" src="../assets/index25.png">

				<!-- 第二组（复制一份，用于无缝循环） -->
				<img class="card" src="../assets/index20.png">
				<img class="card" src="../assets/index21.png">
				<img class="card" src="../assets/index22.png">
				<img class="card" src="../assets/index23.png">
				<img class="card" src="../assets/index24.png">
				<img class="card" src="../assets/index25.png">
			</div>
		</div>
		<div style="height: 2.7rem; width: 1px;" />
		<div class="partnerBox" aria-label="Scrolling cards">
			<div class="track2">
				<!-- 第一组 -->
				<img class="card" src="../assets/index23.png">
				<img class="card" src="../assets/index24.png">
				<img class="card" src="../assets/index25.png">
				<img class="card" src="../assets/index26.png">
				<img class="card" src="../assets/index27.png">
				<img class="card" src="../assets/index28.png">

				<!-- 第二组 （复制一份，用于无缝循环） -->
				<img class="card" src="../assets/index23.png">
				<img class="card" src="../assets/index24.png">
				<img class="card" src="../assets/index25.png">
				<img class="card" src="../assets/index26.png">
				<img class="card" src="../assets/index27.png">
				<img class="card" src="../assets/index28.png">
			</div>
		</div>
		<div style="height: 11.7rem; width: 1px;" />
	</template>
</div>
</template>

<script>
export default {
	data() {
		return {
			isDragging: false,
			startX: 0,
			startScrollLeft: 0,
			activeCoreDataIndex: 1,
		}
	},
	methods: {
		handleDown(event) {
			const line = this.$refs.line

			this.isDragging = true
			this.startX = event.clientX
			this.startScrollLeft = line.scrollLeft

			line.setPointerCapture(event.pointerId)

			window.addEventListener("pointermove", this.handleMove)
			window.addEventListener("pointerup", this.handleUp)
		},
		handleMove(event) {
			if (!this.isDragging) return

			const line = this.$refs.line
			const delta = event.clientX - this.startX

			line.scrollLeft = this.startScrollLeft - delta
		},
		handleUp(event) {
			const line = this.$refs.line

			this.isDragging = false

			try {
				line.releasePointerCapture(event.pointerId)
			} catch (err) {}

			window.removeEventListener("pointermove", this.handleMove)
			window.removeEventListener("pointerup", this.handleUp)
		},

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
	},
}
</script>

<style lang="scss" scoped>
.indexPage {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.wholePageBox {
		width: 100%;
		height: 100vh;
		position: relative;
	}

	.indexImageBox {
		background-color: #212121;
		position: relative;

		.indexImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.indexTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 35%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.indexTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.indexText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

	.visualBox {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.visualBoxItemLine {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100rem;
			height: 24.6rem;

			.visualBoxItem {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				width: 26rem;
				height: 26rem;

				.visualBoxItemImage {
					width: 4.7rem;
					height: 4.7rem;
				}
				.visualBoxItemName {
					font-size: 2rem;
					line-height: 2.8rem;
					color: #333333;
				}
				.visualBoxItemDesc {
					font-size: 1.5rem;
					line-height: 1.8rem;
					color: #666666;
				}
			}
		}
	}

	.courseTypeBox {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
		.courseTypeLine {
			width: 100rem;
			padding-top: 1rem;
			padding-bottom: 5rem;
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			justify-content: flex-start;
			column-gap: 2.667rem;
			overflow-x: scroll;
			scrollbar-width: none;
			-ms-overflow-style: none;
			cursor: grab;
			user-select: none;

			.courseTypeItem {
				width: 23rem;
				height: 24rem;
				box-shadow: 0rem 0.3rem 3.3rem 0rem rgba(51, 51, 51, 0.05);

				.courseTypePic {
					margin-top: 3.3rem;
					width: 5rem;
					height: 5rem;
				}

				.courseTypeName {
					margin-top: 1.7rem;
					width: 100%;
					font-size: 2rem;
					line-height: 3rem;
					text-align: center;
					color: #333333;
				}
				.courseTypeDesc {
					margin-top: 1rem;

					box-sizing: border-box;
					width: 100%;
					padding: 0px 3.3rem;
					font-size: 1.3rem;
					line-height: 2rem;
					text-align: center;
					color: #333333;
				}
			}
		}
		.courseTypeLine:active {
			cursor: grabbing;
		}
		.courseTypeLine::-webkit-scrollbar {
			display: none;
		}
	}

	.coreDataBox {
		width: 100%;
		position: relative;
		width: 100rem;
		height: 16.7rem;
		background-color: rgba(120, 223, 162, 0.10);

		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		padding-left: 4.5rem;
		padding-right: 4.5rem;
		box-sizing: border-box;

		.coreDataItem {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			opacity: 0.8;
			transition: flex 0.3s ease, opacity 0.3s ease;

			.coreDataItemText1 {
				font-size: 3.5rem;
				line-height: 5.3rem;
				color: #78DFA2;
				margin-right: 1.5rem;
				transition: font-size 0.3s ease, line-height 0.3s ease;
			}
			.coreDataItemText2 {
				font-size: 1.5rem;
				line-height: 2.3rem;
				color: #231815;
				transition: font-size 0.3s ease, line-height 0.3s ease;
			}
		}

		.coreDataItem.active {
			opacity: 1;

			.coreDataItemText1 {
				font-size: 4.7rem;   // 3.5 * 1.3
				line-height: 7rem; // 5.3 * 1.3
				font-weight: 600;
			}
			.coreDataItemText2 {
				font-size: 2rem;   // 1.5 * 1.3
				line-height: 3rem; // 2.3 * 1.3
			}
		}
	}

	.partnerBox {
		width: 100%;
		// --card-w: 17.9rem;
		--card-w: 15vw;
		--card-h: 7.3rem;
		--gap6: 2vw;
		--gap5: 6.25vw;
		--gap4: 13.333vw;
		--duration: 60s;

		overflow: hidden;
		width: 100%;
		position: relative;

		/* 轨道：一整条横向 flex */
		.track1 {
			display: flex;
			gap: var(--gap6);
			width: max-content;
			will-change: transform;
			animation: scroll1 var(--duration) linear infinite;
		}
		.track2 {
			display: flex;
			gap: var(--gap6);
			width: max-content;
			will-change: transform;
			animation: scroll2 var(--duration) linear infinite;
		}

		@keyframes scroll1 {
			from {
				transform: translateX(0);
			}
			to {
				transform: translateX(
					calc(-6 * (var(--card-w) + var(--gap6)))
				);
			}
		}
		@keyframes scroll2 {
			from {
				transform: translateX(
					calc(-6 * (var(--card-w) + var(--gap6)))
				);
			}
			to {
				transform: translateX(0);
			}
		}

		/* 卡片占位：你后面直接在这里塞内容/图标 */
		.card {
			flex: 0 0 var(--card-w);
			width: var(--card-w);
			height: var(--card-h);

			box-sizing: border-box;
			background: #FAFAFA;
			object-fit: contain;
		}

		/* 可访问性：用户偏好减少动效时停掉 */
		@media (prefers-reduced-motion: reduce) {
			.track { animation: none; }
		}

		/* 可选：左右渐隐遮罩，更像“跑马灯” */
		.marquee::before,
		.marquee::after {
			content: "";
			position: absolute;
			top: 0; bottom: 0;
			width: 3rem;
			pointer-events: none;
			z-index: 1;
		}
		.marquee::before {
			left: 0;
			background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));
		}
		.marquee::after {
			right: 0;
			background: linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0));
		}
	}
}

.boxCNTitle{
	font-size: 4rem;
	line-height: 4.8rem;
	color: #1D1D1F;
	font-weight: 600;
}
.boxENTitle{
	font-size: 1.7rem;
	line-height: 1.8rem;
	color: #666666;
}
</style>